(() => {
  const slugify = (value) => {
    const normalized = value
      .normalize('NFKD')
      .toLowerCase()
      .trim()
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\p{Letter}\p{Number}]+/gu, '-')
      .replace(/^-+|-+$/g, '');

    return normalized || 'section';
  };

  // The contents heading becomes a button: "On this page (n)", n = main sections. Closed on phones, open on larger
  // screens; data-open on the aside drives the stylesheet, aria-expanded follows it.
  const phoneQuery = window.matchMedia('(max-width: 749px)');
  const initTocToggle = (toc, list) => {
    const label = toc.querySelector(':scope > p');
    if (!label || label.querySelector('button')) return;

    const count = list.querySelectorAll(':scope > li[data-level="2"]').length || list.children.length;
    if (!list.id) list.id = `${toc.dataset.target || 'XEArticle'}-contents`;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'xe-article-toc__toggle';
    button.setAttribute('aria-controls', list.id);
    button.textContent = `${label.textContent.trim()} (${count})`;
    label.replaceChildren(button);

    const setOpen = (open) => {
      toc.toggleAttribute('data-open', open);
      button.setAttribute('aria-expanded', String(open));
    };
    setOpen(!phoneQuery.matches);
    toc.dataset.xeTocToggle = 'true';

    button.addEventListener('click', () => setOpen(!toc.hasAttribute('data-open')));
    phoneQuery.addEventListener?.('change', () => setOpen(!phoneQuery.matches));
  };

  const initArticleToc = (root = document) => {
    root.querySelectorAll('[data-xe-article-toc]').forEach((toc) => {
      if (toc.dataset.initialized === 'true') return;

      const content = document.getElementById(toc.dataset.target);
      const list = toc.querySelector('[data-xe-article-toc-list]');
      if (!content || !list) return;

      const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
      if (headings.length < 2) return;

      const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
      const linksById = new Map();

      headings.forEach((heading, index) => {
        if (!heading.id) {
          const baseId = slugify(heading.textContent);
          let uniqueId = baseId;
          let suffix = 2;

          while (usedIds.has(uniqueId)) {
            uniqueId = `${baseId}-${suffix}`;
            suffix += 1;
          }

          heading.id = uniqueId;
          usedIds.add(uniqueId);
        }

        const item = document.createElement('li');
        item.dataset.level = heading.tagName.slice(1);

        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        if (index === 0) link.classList.add('is-active');

        item.appendChild(link);
        list.appendChild(item);
        linksById.set(heading.id, link);
      });

      toc.hidden = false;
      toc.dataset.initialized = 'true';
      toc.closest('[data-xe-article-layout]')?.classList.add('has-toc');
      initTocToggle(toc, list);

      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((first, second) => first.boundingClientRect.top - second.boundingClientRect.top);

          if (!visible.length) return;

          linksById.forEach((link) => link.classList.remove('is-active'));
          linksById.get(visible[0].target.id)?.classList.add('is-active');
        },
        { rootMargin: '-18% 0px -68% 0px', threshold: 0 }
      );

      headings.forEach((heading) => observer.observe(heading));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initArticleToc());
  } else {
    initArticleToc();
  }

  document.addEventListener('shopify:section:load', (event) => initArticleToc(event.target));
})();
